import { render, staticRenderFns } from "./LopdText.vue?vue&type=template&id=0c6a8172&"
import script from "./LopdText.vue?vue&type=script&lang=js&"
export * from "./LopdText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports